"use strict";
const _ = require('lodash');
const hasExternalReference = entity => {
    if (!entity)
        return false;
    if (!entity.metadata)
        return false;
    return !!_.find(Object.keys(entity.metadata), x => _.includes(x, 'external'));
};
function getExternalCustomerNumber(customerSubUnit, organization) {
    if (!organization) {
        return undefined;
    }
    return _.get(customerSubUnit, `metadata.externalCustomerNumber-${organization.id}`);
}
function getExternalOrderNumber(order, organization) {
    if (!organization) {
        return undefined;
    }
    return _.get(order, `metadata.externalReference-${organization.id}.orderNumber`);
}
function getExternalCustomerNumbers(organizations, customerSubUnit) {
    return (organizations || [])
        .map(organization => getExternalCustomerNumber(customerSubUnit, organization))
        .filter(x => x)
        .join(', ');
}
const getReferencingOrganization = (referenceKey, externalField) => referenceKey.replace(`${externalField}-`, '');
module.exports = {
    getReferencingOrganization,
    getExternalCustomerNumber,
    getExternalCustomerNumbers,
    getExternalOrderNumber,
    hasExternalReference,
};
